var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MapChart',{staticStyle:{"width":"100%"},attrs:{"countryData":Object.assign({}, _vm.mapData),"highColor":"#ee0","lowColor":"#eea","countryStrokeColor":"#444","defaultCountryFillColor":"#eee"}})}
var staticRenderFns = []

export { render, staticRenderFns }